var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-message",staticStyle:{"margin-top":"18px"}},[_c('span',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }